var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","column":"","fill-height":""}},[_c('span',{staticClass:"title resRed-base--text"},[_vm._v("ACCESS DENIED")]),_c('span',[_vm._v("You do not have access to this page.")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }